import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-fields/abstract-value-accessor/abstract-value';
import { makeProvider } from '@shared/form-fields/make-provider';
import { XeroContractOptions } from '@shared/modules/xero/xero-contract-options';
import { equals } from '@shared/utils/helpers';
import { clone } from 'lodash-es';

@Component({
    selector: 'app-xero-contract-options',
    templateUrl: './xero-contract-options.component.html',
    providers: [makeProvider(XeroContractOptionsComponent)],
})
export class XeroContractOptionsComponent extends AbstractInputComponent<XeroContractOptions> {
    _xeroContractOptions: XeroContractOptions;
    _xeroContractOptionsOriginal: XeroContractOptions;

    @Input()
    set xero(value: XeroContractOptions) {
        if (value) {
            this._xeroContractOptions = value;
            this._xeroContractOptionsOriginal = value;
        } else {
            this._xeroContractOptions = {
                department_code: null,
                inventory_item_code: null
            };
            this._xeroContractOptionsOriginal = clone(this._xeroContractOptions);
        }
    }

    @Output() xeroChange = new EventEmitter<XeroContractOptions>();

    onModelChanged($event) {
        const previousXeroOptions = clone(this._xeroContractOptionsOriginal);
        const updatedXeroOptions = clone(this._xeroContractOptions);


        const hasChanged = !equals(previousXeroOptions, updatedXeroOptions);

        if (hasChanged) {
            this.xeroChange.emit(updatedXeroOptions);
        }
    }
}
